import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageMeta, { SITE_URL } from "@/components/base/PageMeta";
import HeroSection from "./components/HeroSection";
import SeoIntroSection from "./components/SeoIntroSection";
import CategoryGrid from "./components/CategoryGrid";
import ComparisonSection from "./components/ComparisonSection";
import ArticleCards from "./components/ArticleCards";
import CtaSection from "./components/CtaSection";
import TestimonialsSection from "./components/TestimonialsSection";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Mulebuy Spreadsheet Hub",
    url: SITE_URL + "/",
    description: "The #1 mulebuy spreadsheet database for verified product sourcing lists. Updated daily with trending finds across electronics, fashion, shoes, and more.",
    potentialAction: {
      "@type": "SearchAction",
      target: SITE_URL + "/?s={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Mulebuy Spreadsheet Hub",
    url: SITE_URL + "/",
    description: "Trusted directory of verified mulebuy spreadsheet collections for product sourcing.",
    sameAs: [
      "https://kaspreadsheet.com/",
    ],
  },
];

export default function Home() {
  return (
    <main>
      <PageMeta
        title="Mulebuy Spreadsheet Hub | Verified Product Sourcing Lists 2026"
        description="Discover the most complete mulebuy spreadsheet database with verified product sourcing lists, updated daily. Browse electronics, fashion, shoes, accessories and trending product finds — your trusted spreadsheet directory for smart shopping."
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <HeroSection />
      <SeoIntroSection />
      <CategoryGrid />
      <ComparisonSection />
      <ArticleCards />
      <CtaSection />
      <TestimonialsSection />
      <Footer />
    </main>
  );
}